// Wildlife Gallery Data - Centralised image management
// All images organised by category to prevent repetition across pages

export const wildlifeGallery = {
  // Hero and featured images (premium quality, landscape oriented)
  featured: [
    {
      id: "new-hero-main",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fabd2884d973d4ee3bac71685bbb4be39?format=webp&width=2560&quality=90",
      alt: "Team collaboration with local authorities - wildlife conservation partnership with rescued baby bird",
      category: "community-partnership",
      aspectRatio: "landscape",
      mobileUrl: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fabd2884d973d4ee3bac71685bbb4be39?format=webp&width=2560&quality=95&height=1200&fit=crop&crop=center&quality=85"
    },
    {
      id: "hero-main",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fe2d779b7056d4f7dbca8778088f974c4?format=webp&width=2560&quality=95",
      alt: "Team member with rescued bird - wildlife rehabilitation in action",
      category: "rehabilitation",
      aspectRatio: "landscape"
    },
    {
      id: "community-outreach",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F0e7dd0c73fdb4ecfb4019a55c5668403?format=webp&width=2560&quality=95",
      alt: "Community wildlife education and outreach programme",
      category: "community",
      aspectRatio: "landscape"
    },
    {
      id: "volunteer-programme",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F9e2a956703fc4a61a5fc903dc1074530?format=webp&width=2560&quality=95",
      alt: "Team collaboration with police officers caring for rescued wildlife - professional partnership in action",
      category: "volunteers",
      aspectRatio: "landscape"
    }
  ],

  // Native Australian birds - main focus of rehabilitation
  birds: [
    {
      id: "wood-duck",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fa4c4036f792f4809ad29248a64c91bb9?format=webp&width=2560&quality=95",
      alt: "Australian Wood Duck - waterfowl rehabilitation",
      species: "Wood Duck",
      category: "waterfowl"
    },
    {
      id: "kookaburra",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F746216c80d0d41a693c0cd86943dabc0?format=webp&width=2560&quality=95",
      alt: "Laughing Kookaburra - iconic Australian bird",
      species: "Laughing Kookaburra", 
      category: "native"
    },
    {
      id: "plover",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F0885f8443a61447dbd059d777dc66707?format=webp&width=2560&quality=95",
      alt: "Spur-winged Plover - ground nesting bird protection",
      species: "Spur-winged Plover",
      category: "ground-birds"
    },
    {
      id: "magpie",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F0f3477d10fea40fdb4d858003140141d?format=webp&width=2560&quality=95",
      alt: "Australian Magpie - intelligent native bird",
      species: "Australian Magpie",
      category: "native"
    },
    {
      id: "duck-feeding",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F6c3d1d01ac7d41499f30df21a7d54a16?format=webp&width=2560&quality=95",
      alt: "Duck being hand-fed during rehabilitation",
      species: "Duck Species",
      category: "rehabilitation"
    },
    {
      id: "honeyeater",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F85f1f353352a4e049ce24a0e63683e7c?format=webp&width=2560&quality=95",
      alt: "Blue-faced Honeyeater - nectar feeding bird",
      species: "Blue-faced Honeyeater",
      category: "nectar-feeders"
    },
    {
      id: "heron",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F8bce462279d646ab816afc8544c63058?format=webp&width=2560&quality=95",
      alt: "White-faced Heron - wetland bird conservation",
      species: "White-faced Heron",
      category: "wetland"
    },
    {
      id: "pale-headed-rosella",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F904f0fdbff784fdda063e2c005d870b9?format=webp&width=2560&quality=95",
      alt: "Pale-headed Rosella - colourful parrot species",
      species: "Pale-headed Rosella",
      category: "parrots"
    }
  ],

  // Parrots and colourful species
  parrots: [
    {
      id: "sulphur-crested-cockatoo-1",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F37cb09af2182436b807200bcbe89fe89?format=webp&width=2560&quality=95",
      alt: "Sulphur-crested Cockatoo - majestic Australian parrot",
      species: "Sulphur-crested Cockatoo",
      category: "large-parrots"
    },
    {
      id: "sulphur-crested-cockatoo-2", 
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F25e1f4fc7e3b4ce19685aafd60cbc822?format=webp&width=2560&quality=95",
      alt: "Sulphur-crested Cockatoo showing crest display",
      species: "Sulphur-crested Cockatoo",
      category: "large-parrots"
    },
    {
      id: "hyacinth-macaw-wing",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F2bf57c0d185d43f0968f814e3a4530ac?format=webp&width=2560&quality=95",
      alt: "Beautiful blue wing feathers of large parrot",
      species: "Large Macaw",
      category: "exotic-parrots"
    },
    {
      id: "lorikeets-pair",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F4660d73d42324285a425d73c9a960b2d?format=webp&width=2560&quality=95",
      alt: "Pair of Rainbow Lorikeets - colourful nectar feeders",
      species: "Rainbow Lorikeet",
      category: "small-parrots"
    },
    {
      id: "galah",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F06100cf7a2e0472e9662bcbb44f96bda?format=webp&width=2560&quality=95",
      alt: "Galah - pink and grey Australian cockatoo",
      species: "Galah", 
      category: "medium-parrots"
    },
    {
      id: "rainbow-lorikeet-hanging",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Ff40e595f6dce4224baec95625e2b42ca?format=webp&width=2560&quality=95",
      alt: "Rainbow Lorikeet feeding on native flowers",
      species: "Rainbow Lorikeet",
      category: "nectar-feeders"
    }
  ],

  // Baby birds and rehabilitation
  babies: [
    {
      id: "baby-bird-teddy",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fbcd9e97f084d4bf7b6d25d308b182050?format=webp&width=2560&quality=95",
      alt: "Orphaned baby bird with comfort teddy during rehabilitation",
      species: "Baby Bird",
      category: "orphans"
    },
    {
      id: "baby-bird-feeding",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F5d58abce4bc047ce9cff57d979cbefcc?format=webp&width=2560&quality=95",
      alt: "Baby bird being hand-fed - critical care",
      species: "Baby Bird",
      category: "feeding"
    },
    {
      id: "young-corella",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fe20e366dd25f4df0857b1d8828614c54?format=webp&width=2560&quality=95",
      alt: "Young Long-billed Corella in rehabilitation",
      species: "Long-billed Corella",
      category: "juveniles"
    },
    {
      id: "baby-swan",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fb14c4bf051b54d7da92d76eba56e75b6?format=webp&width=2560&quality=95",
      alt: "Baby black swan - waterfowl care",
      species: "Black Swan",
      category: "waterfowl-babies"
    }
  ],

  // Unique and special species
  special: [
    {
      id: "tawny-frogmouth",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F5e8d76d579ac4b10bd4785633d5008ed?format=webp&width=2560&quality=95",
      alt: "Tawny Frogmouth - nocturnal Australian bird",
      species: "Tawny Frogmouth",
      category: "nocturnal"
    },
    {
      id: "pelican-close",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F92b9ffef5b43469596cc49e8bd9f14fe?format=webp&width=2560&quality=95",
      alt: "Australian Pelican - large waterbird conservation",
      species: "Australian Pelican",
      category: "large-waterbirds"
    },
    {
      id: "curlew",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F36318d862acc4903b8be7c3770b84664?format=webp&width=2560&quality=95",
      alt: "Bush Stone-curlew - endangered ground bird",
      species: "Bush Stone-curlew",
      category: "endangered"
    },
    {
      id: "black-cockatoo",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fc322c6d990ab412f8d82f4e202720311?format=webp&width=2560&quality=95",
      alt: "Red-tailed Black Cockatoo - rare native parrot",
      species: "Red-tailed Black Cockatoo",
      category: "rare-species"
    },
    {
      id: "tawny-frogmouth-new",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F6a7a1a09dfcc4d7d8305073737b4ec30?format=webp&width=800",
      alt: "Tawny Frogmouth - unique Australian bird with striking orange eyes",
      species: "Tawny Frogmouth",
      category: "native-birds"
    },
    {
      id: "new-cockatoo",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F2e82f3ef851b44cdb8e42f073d01cc5d?format=webp&width=800",
      alt: "Sulphur-crested Cockatoo - beautiful white Australian parrot with yellow crest",
      species: "Sulphur-crested Cockatoo",
      category: "large-parrots"
    },
    {
      id: "tawny-frogmouth-pair",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F48bf8564ebab4cd9b30ed8e8869e013a?format=webp&width=800",
      alt: "Pair of Tawny Frogmouths - remarkable Australian birds with distinctive orange eyes in their natural habitat",
      species: "Tawny Frogmouth",
      category: "native-birds"
    }
  ],

  // Action and care photos
  rehabilitation: [
    {
      id: "hand-feeding-bird",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F616a1da8fc654ddca45ca8235b07fef9?format=webp&width=2560&quality=95",
      alt: "Hand feeding rescued bird - specialised care",
      species: "Rehabilitation Bird",
      category: "feeding"
    },
    {
      id: "jenni-with-birds", 
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F46bb88fa23174396a9c02a77c991b0e4?format=webp&width=2560&quality=95",
      alt: "Founder Jenni with rehabilitated birds",
      species: "Multiple Species",
      category: "founder"
    },
    {
      id: "kookaburras-pair",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F3331bc6acd714c0d8b459fa0db9f1b32?format=webp&width=2560&quality=95",
      alt: "Team members and community volunteers working together - building wildlife conservation partnerships",
      species: "Team Partnership",
      category: "community-buddies"
    }
  ],

  // Detail and beauty shots for backgrounds
  backgrounds: [
    {
      id: "lorikeet-detail",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fa7cbe8ad525f4032b68c24dd6562926a?format=webp&width=2560&quality=95",
      alt: "Close-up of colourful lorikeet feathers",
      species: "Rainbow Lorikeet",
      category: "detail"
    },
    {
      id: "rosella-colorful",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fcb2a84359b42416498f1204e0a48d5d5?format=webp&width=2560&quality=95",
      alt: "Vibrant Rosella showing natural colours",
      species: "Rosella",
      category: "colourful"
    },
    {
      id: "parakeet-detail",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fccd96f7007244624ab649505ae24b724?format=webp&width=2560&quality=95",
      alt: "Beautiful parakeet detail shot",
      species: "Parakeet",
      category: "detail"
    },
    {
      id: "kookaburra-portrait",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F4c2fe04f52af4a61beeadc654fcfeb25?format=webp&width=2560&quality=95",
      alt: "Kookaburra portrait - expressive eyes",
      species: "Laughing Kookaburra", 
      category: "portrait"
    },
    {
      id: "frogmouth-amazing",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2Fa29496e9f2da4b0194647e5c835a8535?format=webp&width=2560&quality=95",
      alt: "Amazing Tawny Frogmouth with wide mouth display",
      species: "Tawny Frogmouth",
      category: "unique"
    }
  ],

  // Remaining photos for variety
  additional: [
    {
      id: "young-kookaburra",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F92267ff3c2624c70b9af11bd6e7fcdd9?format=webp&width=2560&quality=95",
      alt: "Young Kookaburra learning to hunt",
      species: "Laughing Kookaburra",
      category: "juveniles"
    },
    {
      id: "bird-cage-recovery",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F93cb7641bd2f4ab49ee67333d4b197e9?format=webp&width=2560&quality=95",
      alt: "Bird in recovery cage - rehabilitation facility",
      species: "Recovery Bird",
      category: "facilities"
    },
    {
      id: "bird-in-care",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F0e7bff3298a742768e6923efe888c75c?format=webp&width=2560&quality=95",
      alt: "Bird receiving specialised veterinary care",
      species: "Care Bird", 
      category: "medical"
    },
    {
      id: "stone-curlew-ground",
      url: "https://cdn.builder.io/api/v1/image/assets%2F35ffb80beae24a4483ace4ab1c92b206%2F14d935a5947645d086c5849a4ec557f2?format=webp&width=2560&quality=95",
      alt: "Bush Stone-curlew in natural ground habitat",
      species: "Bush Stone-curlew",
      category: "ground-birds"
    }
  ]
};

// Helper functions for image management
export const getImageById = (id) => {
  const allImages = Object.values(wildlifeGallery).flat();
  return allImages.find(img => img.id === id);
};

export const getImagesByCategory = (category) => {
  const allImages = Object.values(wildlifeGallery).flat();
  return allImages.filter(img => img.category === category);
};

export const getRandomImages = (count, excludeIds = []) => {
  const allImages = Object.values(wildlifeGallery).flat();
  const availableImages = allImages.filter(img => !excludeIds.includes(img.id));
  
  // Shuffle array and return first 'count' items
  const shuffled = [...availableImages].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

export const getAllImages = () => {
  return Object.values(wildlifeGallery).flat();
};

// Page-specific image allocations to prevent repetition
export const pageImageAllocations = {
  home: {
    hero: 'new-hero-main',
    successStory: 'tawny-frogmouth-pair',
    pillars: ['wood-duck', 'kookaburra', 'hero-main', 'baby-bird-teddy'],
    gallery: ['tawny-frogmouth-new', 'galah', 'new-cockatoo', 'pelican-close', 'curlew', 'black-cockatoo']
  },
  about: {
    mission: 'rainbow-lorikeet-hanging',
    history: 'community-outreach',
    values: ['pale-headed-rosella', 'honeyeater', 'heron', 'magpie'],
    gallery: ['hyacinth-macaw-wing', 'baby-bird-feeding', 'young-corella', 'hand-feeding-bird']
  },
  whatWeDo: {
    pillars: ['volunteer-programme', 'plover', 'duck-feeding', 'kookaburras-pair'],
    gallery: ['baby-swan', 'sulphur-crested-cockatoo-2', 'young-kookaburra', 'bird-cage-recovery']
  },
  careMap: {
    gallery: ['bird-in-care', 'stone-curlew-ground', 'lorikeet-detail', 'rosella-colorful']
  },
  backgrounds: {
    sections: ['parakeet-detail', 'kookaburra-portrait', 'frogmouth-amazing']
  }
};
